import React from 'react';
import { useEditor } from '@splashthat/splash-cms-engine';
import { renderSidebar } from 'common/components/TouchpointEditor/renderer/sidebarRenderer';
import { SidebarPanel } from 'common/components/TouchpointEditor/components/TouchpointSidebar';

export default function ElementsListMenu() {
    const editor = useEditor(({ nodes }) => ({ nodes }));
    const root = Object.values(editor.nodes).find((node) => node.root);
    return <SidebarPanel>{renderSidebar(editor.nodes, root, editor.actions)}</SidebarPanel>;
}
